export const SETTINGS = {
  AUTO_REFRESH_MINUTE: false,
  AUTO_REFRESH_HOUR: false,
  SHOW_SECONDS: false,
  SHOW_SECONDS_UTC: true,
};
